import QrValidation from '@/views/certificates/QrValidate.vue'
import CertificateValidation from '@/views/certificates/Validation.vue'

const certificates = [
    {
        path: '/certificate-validation',
        name: 'QrValidate',
        component: QrValidation,
        children: [],
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/certificate-validation/:token',
        name: 'CertificateValidation',
        component: CertificateValidation,
        children: [],
        meta: {
            requiresAuth: false
        },
        props: (route) => ({ token: route.params.token }),
    },
]

export default certificates
